import { LevelCard } from '../components/LevelCard'
import type { LevelMeta, StorageState } from '../logic/types'

interface Props {
  levels: LevelMeta[]
  exercisesByLevel: Record<number, number>
  state: StorageState
  onPickLevel: (level: number) => void
  onOpenSettings: () => void
}

export function Home({ levels, exercisesByLevel, state, onPickLevel, onOpenSettings }: Props) {
  const totalMastered = Object.keys(state.mastered).length
  const streak = state.stats.streak
  const showStreak = streak.count >= 1

  return (
    <section className="screen active" id="scr-home">
      <div className="home-wrap">
        <div className="home-top">
          <div>
            <h1 className="brand">Hebben <em>of</em> zijn?</h1>
            <div className="brand-sub">Тренажёр перфектума · нидерландский</div>
          </div>
          <button
            className="icon-btn"
            aria-label="Настройки"
            onClick={onOpenSettings}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
              <circle cx="12" cy="12" r="3.2" />
              <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 8.98 19.4a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1.03H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.6 8.98a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34H9a1.7 1.7 0 0 0 1.03-1.56V3a2 2 0 1 1 4 0v.09c0 .68.4 1.3 1.03 1.56a1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87V9c.26.63.88 1.03 1.56 1.03H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.56 1.03Z" />
            </svg>
          </button>
        </div>

        <div className="chips">
          {showStreak && (
            <span className="chip">🔥 <span className="num">Серия: {streak.count} {pluralDays(streak.count)}</span></span>
          )}
          <span className="chip neutral">освоено:&nbsp;<span className="num">{totalMastered}</span></span>
        </div>

        <div className="levels">
          {levels.map((lv) => {
            const total = exercisesByLevel[lv.level] ?? 0
            const mastered = countMasteredForLevel(state, lv.level)
            return (
              <LevelCard
                key={lv.level}
                level={lv}
                mastered={mastered}
                total={total}
                onClick={() => onPickLevel(lv.level)}
              />
            )
          })}
        </div>

        <div className="home-note">
          Прогресс сохраняется в браузере — обновите страницу и проверьте.
        </div>
      </div>
    </section>
  )
}

function countMasteredForLevel(state: StorageState, level: number): number {
  const prefix = `l${level}-`
  let n = 0
  for (const k of Object.keys(state.mastered)) {
    if (k.startsWith(prefix)) n++
  }
  return n
}

function pluralDays(n: number): string {
  // Russian declension: 1 день, 2-4 дня, 5-20 дней
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return 'день'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'дня'
  return 'дней'
}
